/**
 * ====================================================================
 * WeLearn Pro Player: Default WeLearnPro system configuration
 * This is a configuration that appreciable to WeLearnPro system
 * ====================================================================
 */

const wlpDefaultsOptions = {
    video: 'https://cdn.plyr.io/static/blank.mp4',
    embedVideo: false,
    seekable: true,
    debug: false,
    thumbnail: '',
    progress: {
        update: {
            url: '/Learning/UpdateProgressData/',
            interval: 15000,
            alert: true,
        }
    },
    note: {
        get: {
            url: '/Learning/SelectNote/',
        },
        save: {
            url: '/Learning/CreateNote/',
        },
        update: {
            url: '/Learning/UpdateNote/',
        },
        delete: {
            url: '/Learning/DeleteNote/',
        }
    },
    chat: {
        get: {
            url: '/Learning/GetChat/',
        },
        insert: {
            urlQuestion: '/Learning/PostQuestion/',
            urlAnswer: '/Learning/PostAnswer/'
        }
    },
    quiz: {
        invokeOnce: false
    }
};

export { wlpDefaultsOptions }
